import {
  type ChatMessageModel,
  type ChatMessageTypeEnumEnum,
  type ChatStatusEnumEnum,
} from '@/shared/api'

export const ChatStatusEnum = {
  Opened: 1 as ChatStatusEnumEnum,
  Closed: 2 as ChatStatusEnumEnum,
} as const

export type ChatStatusEnum =
  (typeof ChatStatusEnum)[keyof typeof ChatStatusEnum]

export const chatStatusAsArray = Object.values(ChatStatusEnum)
export const getChatStatusString = (type: ChatStatusEnum) => {
  switch (type) {
    case ChatStatusEnum.Opened:
      return 'Активное'
    case ChatStatusEnum.Closed:
      return 'Закрыто'
    default:
      return 'Неизвестный статус обращения'
  }
}

export const ChatMessageTypeEnum = {
  UsersMessage: 0 as ChatMessageTypeEnumEnum,
  SystemMessage: 1 as ChatMessageTypeEnumEnum,
} as const

export enum GroupMessageType {
  DATE = 'date',
  UNREAD = 'unread',
  USER_MESSAGE = 'user_message',
  SYSTEM_MESSAGE = 'system_message',
}

export type GroupMessageItem =
  | { type: GroupMessageType.UNREAD }
  | { type: GroupMessageType.DATE; date: string }
  | { type: GroupMessageType.USER_MESSAGE; item: ChatMessageModel }
  | { type: GroupMessageType.SYSTEM_MESSAGE; item: ChatMessageModel }
